import { render, staticRenderFns } from "./ActualDateBlock.vue?vue&type=template&id=23b7ebab&"
import script from "./ActualDateBlock.vue?vue&type=script&lang=js&"
export * from "./ActualDateBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports